<template>
  <v-row v-if="this.status && this.status.total_devices > 0" class="ma-2">
    
    <v-dialog
      v-model="showOnlineDevices"
      max-width="80%"
    >
      <videon-card heading="Online Devices" showClose="true" @close="showOnlineDevices = false">
        <v-card-text>
          <device-list v-model="devicesOnline"/>
        </v-card-text>
      </videon-card>
    </v-dialog>
    
    <v-dialog
      v-model="showStreamingDevices"
      max-width="80%"
    >
      <videon-card heading="Streaming Devices" showClose="true" @close="showStreamingDevices = false">
        <v-card-text>
          <device-list v-model="devicesStreaming"/>
        </v-card-text>
      </videon-card>
    </v-dialog>
    
    <v-dialog
      v-model="showAlertDevices"
      max-width="80%"
    >
      <videon-card heading="Alerts" showClose="true" @close="showAlertDevices = false">
        <v-card-text>
          <v-data-table
            :headers="alertHeaders"
            :items="alerts"
            sort-by="timestamp"
            :sort-desc="true"
            hide-default-footer
            :items-per-page="1000"
          >
            <template v-slot:item.label="{ item }">
              <span class="subtitle-2">{{ item.label }}</span>
            </template>
            <template v-slot:item.resolved="{ item }">
              <alert-state-label :alert="item" />
            </template>
            <template v-slot:item.device_guid="{ item }">
              <device-label :device="$devices.getDevice(item.device_guid)" />
            </template>
            <template v-slot:item.timestamp="{ item }">
              {{ item.timestamp | moment("YYYY/MM/DD hh:mm:ss a") }}
            </template>
          </v-data-table>
        </v-card-text>
      </videon-card>
    </v-dialog>
    
    <videon-metric-tile :color="online.color" heading="Online Devices" icon="devices" :description="online.label" width="30%" large class="ma-1" @click="showOnlineDevices = true" />
    <videon-metric-tile :color="streaming.color" heading="Streaming Devices" icon="radio_button_checked" :description="streaming.label" width="30%" large class="ma-1" @click="showStreamingDevices = true" />
    <videon-metric-tile :color="alerting.color" heading="Alerts" icon="notifications_active" :description="alerting.label" width="30%" large class="ma-1" @click="viewAlerts" />
  </v-row>
</template>

<script>
  import DeviceList from '../../../components/device/components/DeviceList.vue'

  export default {
    name: 'DeviceStatusTiles',
    
    components: {
      DeviceList,
    },
    
    props: ['status', 'useAlerts'],
    
    computed: {
      online() {
        if (this.status && this.status.total_devices !== undefined) {
          var color = 'info' //(this.status.total_online < this.status.total_devices) ? 'red' : 'green'
          if (this.status.total_devices == 0) {
            color = 'grey'
          }
          return {'label': '' + parseInt(this.status.total_online) + '/' + parseInt(this.status.total_devices), 'color': color}
        }
        return {'label': 'Unknown', 'color': 'grey'}
      },
      
      streaming() {
        if (this.status && this.status.total_devices !== undefined) {
          var color = 'info' //(this.status.total_streaming < this.status.total_devices) ? 'red' : 'green'
          return {'label': '' + parseInt(this.status.total_streaming) + '/' + parseInt(this.status.total_devices), 'color': color}
        }
        return {'label': 'Unknown', 'color': 'grey'}
      },
      
      alerting() {
        if (this.status && this.status.total_alerts !== undefined) {
          var color = (this.status.total_alerts > 0) ? 'red' : 'info'
          return {'label': '' + parseInt(this.status.total_alerts), 'color': color}
        }
        
        return {'label': 'Unknown',  'color': 'grey'}
      },
      
      
      devicesOnline() {
        if (this.status.devices_online) {
          return this.status.devices_online.map((device_guid) => this.$devices.getDevice(device_guid))
        }
        return []
      },
      
      devicesStreaming() {
        if (this.status.devices_online) {
          return this.status.devices_streaming.map((device_guid) => this.$devices.getDevice(device_guid))
        }
        return []
      },
      
      alerts() {
        if (this.status.alerts) {
          return this.status.alerts.filter(
            (alertObject) => alertObject.alert_guid && this.$alerts.alertByGUID(alertObject.alert_guid, alertObject.device_guid)).map(
              (alertObject) => this.$alerts.alertByGUID(alertObject.alert_guid, alertObject.device_guid)
            )
        }
        return []
      }
    }, 
    
    data() {
      return {
        showOnlineDevices: false,
        showStreamingDevices: false,
        showAlertDevices: false,
        
        alertHeaders: [
          { text: 'Device', align: 'start text-no-wrap', value: 'device_guid', sortable: false },
          { text: 'Alert', align: 'start', value: 'label', sortable: true, width: '25%' },
          { text: 'Created', align: 'start', value: 'timestamp', sortable: false },
          { text: 'State', align: 'start', value: 'resolved', sortable: false},
        ],
      }
    },
    
    methods: {
      viewAlerts() {
        if (this.status.total_alerts > 0) {
          this.showAlertDevices = true
        } else {
          this.$router.push('/alerts')
        }
      }
    }
  }
</script>